import { createAction } from '@lingoda/core';
import type { BookingFilter } from '../models';

export const setFilter = createAction<Partial<BookingFilter>>('booking/SET_FILTER');
